import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import LicensePlate from "@/pages/LicensePlate";
import Connect from "@/pages/Connect";
import Accessibility from "@/pages/Accessibility";
import Gallery from "@/pages/Gallery";
import Events from "@/pages/Events";
import Resources from "@/pages/Resources";
import NotFound from "@/pages/NotFound";
import Login from "@/pages/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminHome from "@/pages/admin/AdminHome";
import AdminEvents from "@/pages/admin/AdminEvents";
import AdminGallery from "@/pages/admin/AdminGallery";
import AdminLeaders from "@/pages/admin/AdminLeaders";
import AdminResources from "@/pages/admin/AdminResources";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminHomeContent from "@/pages/admin/AdminHomeContent";
import AdminAccount from "@/pages/admin/AdminAccount";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public site */}
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/events" element={<Events />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/overdose-awareness-license-plates" element={<LicensePlate />} />
              <Route path="/connect-with-us" element={<Connect />} />
              <Route path="/accessibility" element={<Accessibility />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            {/* Auth */}
            <Route path="/admin/login" element={<Login />} />
            {/* Admin */}
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<AdminHome />} />
              <Route path="events" element={<AdminEvents />} />
              <Route path="gallery" element={<AdminGallery />} />
              <Route path="leaders" element={<AdminLeaders />} />
              <Route path="resources" element={<AdminResources />} />
              <Route path="home-content" element={<AdminHomeContent />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="account" element={<AdminAccount />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
